angular.module('impactx.rfq').controller('RFQEditBuyerCtrl', RFQEditBuyerCtrl);
RFQEditBuyerCtrl.$inject = [
    '$scope',
    'dataGen',
    '$context',
    '$redirect',
    '$routeParams',
    'ToastService',
    'BackService',
    'ToolbarService',
    '$mdDialog',
    'OutsourcedCommentSaveService',
    '$q'
];

function RFQEditBuyerCtrl($scope, dataGen, $context, $redirect, $routeParams, ToastService, BackService, ToolbarService,
                          $mdDialog, OutsourcedCommentSaveService, $q) {
    $scope.selectedItems = [];
    $scope.isBuyer = true;
    var self = this;

    if ($routeParams.rfqsId > 0) {
        dataGen.getData($scope, {id: $routeParams.rfqsId}, "/rfq/viewsinglerfqs").then(function () {
            $scope.buttonDefinition = [
                {
                    label: $scope.trns.send,
                    action: self.send,
                    type: 'validation',
                    condition: self.canSend,
                    params: {
                        form: $scope.dialogData,
                        disableExpression: {
                            valueFunction: function () {
                                var supplierHeader = $scope.data.supplierHeaders[0]
                                return !impactX.isDefined(supplierHeader, 'items.length');
                            },
                            error: $scope.trns.needOneItem
                        }
                    }
                },
                {
                    label: $scope.trns.save,
                    action: self.save,
                    type: 'validation',
                    condition: self.canSend,
                    params: {form: $scope.dialogData}
                },
                {
                    label: $scope.trns.addItem,
                    action: self.addItem,
                    type: 'dialogaction',
                    condition: self.canAddItem
                },
                {
                    label: $scope.trns.editItem,
                    action: self.editItem,
                    type: 'dialogaction',
                    condition: self.canEditItem
                },
                {
                    label: $scope.trns.remove,
                    action: self.removeItem,
                    type: 'dialogaction',
                    condition: self.canRemoveItem
                },
                {label: $scope.trns.comment, action: self.toggleItemComment, type:'dialogaction', condition: self.canItemComment},
                {label: $scope.trns.comment, action: self.toggleSupplierComment, type:'dialogaction', condition: self.canSupplierComment},
                {label: $scope.trns.addToBasket, action: self.addToBasket, type:'dialogaction', condition: self.canAddToBasketSelected},
                {label: $scope.trns.cancel, action: self.cancel, type:'dialogaction', condition: self.canCancelSelected},
                {label: $scope.trns.resend, action: self.resend, type:'dialogaction', condition: self.canReSendSelected},
                {label: $scope.trns.addToBasket, action: self.addToBasket, type:'dialogaction', condition: self.canAddToBasketFirst},
                {label: $scope.trns.cancel, action: self.cancel, type:'dialogaction', condition: self.canCancelFirst},
                {label: $scope.trns.resend, action: self.resend, type:'dialogaction', condition: self.canReSendFirst},
                {
                    label: $scope.trns.print,
                    type: 'print',
                    condition: self.canPrint,
                    params: {
                        printTokenFunction: self.getPrintToken
                    }
                }
            ];

            ToolbarService.setButtons($scope.buttonDefinition);
        });
    }
    else {
        $mdDialog.show({
            controller: 'RFQContractSelectionCtrl',
            controllerAs: '$ctrl',
            templateUrl: 'modules/rfq/templates/rfqcontractselection.tmpl.html',
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: true
        }).then(function (result) {
            var paramObj = {
                supplierId: result.supplierId,
                cscId: result.cscId,
                lotId: result.lotId
            };
            dataGen.getData($scope, paramObj, "/rfq/newsinglerfqs").then(function () {
                $scope.buttonDefinition = [
                    {
                        label: $scope.trns.send,
                        action: self.send,
                        type: 'validation',
                        params: {
                            form: $scope.dialogData,
                            disableExpression: {
                                valueFunction: function () {
                                    var supplierHeader = $scope.data.supplierHeaders[0]
                                    return !impactX.isDefined(supplierHeader, 'items.length');
                                },
                                error: $scope.trns.needOneItem
                            }
                        }
                    },
                    {
                        label: $scope.trns.save,
                        action: self.save,
                        type: 'validation',
                        params: {form: $scope.dialogData}
                    },
                    {
                        label: $scope.trns.addItem,
                        action: self.addItem,
                        type: 'dialogaction',
                        condition: self.canAddItem
                    },
                    {
                        label: $scope.trns.editItem,
                        action: self.editItem,
                        type: 'dialogaction',
                        condition: self.canEditItem
                    },
                    {
                        label: $scope.trns.remove,
                        action: self.removeItem,
                        type: 'dialogaction',
                        condition: self.canRemoveItem
                    },
                    {
                        label: $scope.trns.comment,
                        action: self.toggleItemComment,
                        type: 'dialogaction',
                        condition: self.canItemComment
                    },
                    {
                        label: $scope.trns.comment,
                        action: self.toggleSupplierComment,
                        type: 'dialogaction',
                        condition: self.canSupplierComment
                    }
                ];

                ToolbarService.setButtons($scope.buttonDefinition);
            });
        }, function () {
            BackService.back();
        });
    }

    $scope.showItemComments = {value: false};
    $scope.showSupplierComments = {value: false};

    this.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };

    this.toggleSupplierComment = function () {
        $scope.showSupplierComments.value = !$scope.showSupplierComments.value;
    };

    this.selectSupplier = function (event, supplier) {
        $scope.showItemComments.value = false;
        $scope.showSupplierComments.value = false;
        for (var i = 0; i < $scope.selectedItems.length; i++) {
            $scope.selectedItems[i].selected = false;
        }
        $scope.selectedItems.splice(0, 1);

        if ($scope.selectedSupplier[0] !== supplier) {
            $scope.selectedSupplier[0] = supplier;
        }
        else {
            $scope.selectedSupplier.splice(0, 1);
        }
    };

    this.addToBasket = function () {
        var rfqsId = 0;
        if (self.canAddToBasketFirst()) {
            rfqsId = $scope.data.supplierHeaders[0].id;
        }
        else if (self.canAddToBasketSelected()) {
            rfqsId = $scope.selectedSupplier[0].id;
        }
        if (rfqsId > 0) {
            return dataGen.postAsForm({}, {rfqsId: rfqsId}, "/rfq/addtobasketrfqs").then(function (data) {
                $context.refreshBasket({}, dataGen, $context);
                ToastService.openStandardToast(data.trns.success);
                $redirect.redirectTo(null, "/basket");
            });
        }
    };

    this.cancel = function () {
        var rfqsId = 0;
        if (self.canCancelFirst()) {
            rfqsId = $scope.data.supplierHeaders[0].id;
        }
        else if (self.canCancelSelected()) {
            rfqsId = $scope.selectedSupplier[0].id;
        }
        if (rfqsId > 0) {
            return dataGen.postAsForm({}, {rfqsId: rfqsId}, "/rfq/cancelrfqs").then(function (data) {
                ToastService.openStandardToast(data.trns.success);
                BackService.back();
            });
        }
    };

    this.resend = function () {
        var rfqsId = 0;
        if (self.canReSendFirst()) {
            rfqsId = $scope.data.supplierHeaders[0].id;
        }
        else if (self.canReSendSelected()) {
            rfqsId = $scope.selectedSupplier[0].id;
        }
        if (rfqsId > 0) {
            return dataGen.postAsForm({}, {rfqsId: rfqsId}, "/rfq/resendrfqs").then(function (data) {
                ToastService.openStandardToast(data.trns.success);
                BackService.back();
            });
        }
    };

    self.canItemComment = function() {
        return $scope.data.canComment && $scope.selectedItems.length > 0;
    };

    self.canSupplierComment = function() {
        return $scope.data.canComment && $scope.selectedSupplier.length > 0;
    };

    self.canAddToBasketSelected = function() {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canAddToBasket && !$scope.selectedItems.length;
    };

    self.canAddToBasketFirst = function() {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canAddToBasket && $scope.data.supplierHeaders.length === 1 && !$scope.selectedItems.length;
    };

    self.canCancelSelected = function() {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canCancel && !$scope.selectedItems.length;
    };

    self.canCancelFirst = function() {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canCancel && $scope.data.supplierHeaders.length === 1 && !$scope.selectedItems.length;
    };

    self.canReSendSelected = function() {
        return $scope.selectedSupplier.length > 0 && $scope.selectedSupplier[0].canResend && !$scope.selectedItems.length;
    };

    self.canReSendFirst = function() {
        return !$scope.selectedSupplier.length && $scope.data.supplierHeaders[0].canResend && $scope.data.supplierHeaders.length === 1 && !$scope.selectedItems.length;
    };

    self.canPrint = function() {
        return ($scope.data.supplierHeaders.length === 1 || ($scope.selectedSupplier.length > 1 && $scope.selectedSupplier.length > 0)) && !$scope.selectedItems.length;
    };

    self.canAddItem = function() {
        return self.canSend() && !$scope.selectedItems.length;
    };

    self.canEditItem = function() {
        return self.canSend() && $scope.selectedItems.length === 1 && !$scope.selectedItems[0].isCanceled;
    };

    self.canRemoveItem = function() {
        return self.canEditItem();
    };

    self.canSend = function () {
        return $scope.data.canSend;
    };

    self.save = function () {
        return saveInternal().then(function(data) {
            if (data && data.data) {
                saveAllComments(data.data.tokens).then(function () {
                    BackService.back();
                });
            }
            else {
                restoreAllComments();
            }
        }, function () {
            restoreAllComments();
        })
    };

    self.send = function () {
        return saveInternal().then(function (data) {
            if (data && data.data) {
                saveAllComments(data.data.tokens).then(function () {
                    dataGen.postAsForm({}, {rfqhId: data.data.rfqhId}, '/rfq/sendnewsinglerfq').then(function () {
                        BackService.back();
                    });
                });
            }
            else {
                restoreAllComments();
            }
        }, function () {
            restoreAllComments()
        });
    };

    var COMMENT_CACHE = {};
    function extractAllComments() {
        var rfqs = $scope.data.supplierHeaders[0];
        extractComments(rfqs);
        angular.forEach(rfqs.items, function (rfqi) {
            extractComments(rfqi);
        });
    }

    function extractComments(baseItem) {
        if (impactX.isDefined(baseItem, 'comments.externalComments.newComments')) {
            COMMENT_CACHE[baseItem.comments.externalComments.commentToken] = baseItem.comments.externalComments.newComments;
            baseItem.comments.externalComments.newComments = [];
        }
        if (impactX.isDefined(baseItem, 'comments.internalComments.newComments')) {
            COMMENT_CACHE[baseItem.comments.externalComments.commentToken] = baseItem.comments.internalComments.newComments;
            baseItem.comments.internalComments.newComments = [];
        }
    }

    function restoreAllComments() {
        var rfqs = $scope.data.supplierHeaders[0];
        restoreComments(rfqs);
        angular.forEach(rfqs.items, function (rfqi) {
            restoreComments(rfqi);
        });
    }

    function restoreComments(baseItem) {
        if (COMMENT_CACHE.hasOwnProperty(baseItem.comments.externalComments.commentToken)) {
            baseItem.comments.externalComments.newComments = COMMENT_CACHE[baseItem.comments.externalComments.commentToken];
        }
        if (COMMENT_CACHE.hasOwnProperty(baseItem.comments.internalComments.commentToken)) {
            baseItem.comments.internalComments.newComments = COMMENT_CACHE[baseItem.comments.internalComments.commentToken];
        }
    }

    function saveAllComments(newTokenMap) {
        var defer = $q.defer();
        if (newTokenMap) {
            var tokens = Object.getOwnPropertyNames(COMMENT_CACHE);
            saveOneCommentAndCallNext(tokens, 0, newTokenMap, defer);
        }
        return defer.promise;
    }

    function saveOneCommentAndCallNext(tokens, iterator, newTokenMap, defer){
        if (tokens.length > iterator) {
            var token = tokens[iterator];
            if (newTokenMap.hasOwnProperty(token)) {
                OutsourcedCommentSaveService.saveCommentsByToken(newTokenMap[token],
                    COMMENT_CACHE[token], false).then(function () {
                    iterator++;
                    saveOneCommentAndCallNext(tokens, iterator, newTokenMap, defer)
                }, function () {
                    COMMENT_CACHE = {};
                    defer.reject();
                })
            }
        }
        else {
            COMMENT_CACHE = {};
            defer.resolve();
        }
    }

    function saveInternal() {
        extractAllComments();
        var params = {
            rfqHeaderDTO: $scope.data
        };
        return dataGen.postAsForm({}, params, '/rfq/savenewsinglerfq');
    }

    self.editItem = function (event) {
        var copiedItem = JSON.parse(JSON.stringify($scope.selectedItems[0]));
        openEditItemDialog(event, copiedItem).then(function(item) {
            if (item) {
                $scope.selectedItems[0].name = item.name;
                $scope.selectedItems[0].supplierNo = item.supplierNo;
                $scope.selectedItems[0].description = item.description;
                $scope.selectedItems[0].unit = item.unit;
                $scope.selectedItems[0].amount = item.amount;
                $scope.selectedItems[0].cUnitsPerOUnit = item.cUnitsPerOUnit;
                $scope.selectedItems[0].contentUnit = item.contentUnit;
                $scope.selectedItems[0].selected = false;
                $scope.selectedItems = [];
            }
        });
    };

    self.removeItem = function (event) {
        var item = $scope.selectedItems[0];
        var items = $scope.data.supplierHeaders[0].items;
        var index = items.indexOf(item);
        $scope.data.supplierHeaders[0].items.splice(index, 1);
        $scope.selectedItems.length = 0;
    }

    self.addItem = function (event) {
        dataGen.getData({}, {}, "/rfq/newsinglerfqi").then(function (data) {
            if (data && data.data) {
                openEditItemDialog(event, data.data, true).then(function (item) {
                    if (item) {
                        if (!$scope.data.supplierHeaders[0].items) {
                            $scope.data.supplierHeaders[0].items = [];
                        }
                        item.position = $scope.data.supplierHeaders[0].items.length + 1;
                        $scope.data.supplierHeaders[0].items.push(item);
                    }
                });
            }
        });
    };

    function openEditItemDialog (event, item, isNew) {
        return $mdDialog.show({
            templateUrl: "modules/rfq/templates/changerfqitem.tmpl.html",
            controller: "RFQChangeItemCtrl",
            controllerAs: "rfqChangeItemCtrl",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                headerLabel: isNew ? $scope.trns.addItem : item.name.value,
                item: item,
                isBuyer: true
            }
        });
    }

    self.getPrintToken = function() {
        if ($scope.selectedSupplier.length > 0) {
            var tokenIdentifier = 'rfqs-' + $scope.selectedSupplier[0].id;
            return $scope.printTokens[tokenIdentifier];
        }
        else if ($scope.data.supplierHeaders.length === 1) {
            return $scope.printTokens.first
        }
    }
}